import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Constants } from "../../CommonMethhods/Constants";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Sidebar from "../../Components/Sidebar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import Loader from "../../Components/Common/Loader";
import RevenueTable from "../../Components/ReportTables/RevenueTable";
import { toast } from "react-toastify";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { useDebounce } from "../../Components/useDebounce";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import DurationChangeComponent from "./DurationChangeComponent";

function ClientWiseRevenueReport() {
  const storeToken = localStorage.getItem("ssoToken");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [gridVal, setGridVal] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [brokingDrop, setBrokingDrop] = useState("All");
  const [count, setCount] = useState();
  const [subBrokingType, setSubBrokingType] = useState("EQUITY");
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState(false);
  const [DateErrorResp, setDateErrorResp] = useState("");
  const [serverError, setServerError] = useState("");
  const [show, setShow] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [totalValue, setTotalValue] = useState();
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration, setSelectDuration] = useState("")
  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    setLoader(true);
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();

    const newYear = `0${current.getMonth() + 1}-01-${CurrentYear}`;
    const date = `${current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
    const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(newYear);
    setToDate(date1);
  }

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleFromDateChange = (e) => {
    document.querySelector("#SearchInput_RevenueR").value = "";
    setGridVal([]);
    setClientCode("");
    setError(false);
    // setFileType("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setDateErrorResp("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    document.querySelector("#SearchInput_RevenueR").value = "";
    setGridVal([]);
    setClientCode("");
    setError(false);
    // setFileType("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setDateErrorResp("");
    setServerError("");
  };

  const getRevenueClientReport = async (
    fileType,
    sizePage,
    pageNo = 1,
    mainLoader = false
  ) => {
    let clientCo = document.querySelector("#SearchInput_RevenueR").value;

    if (fileType === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (fileType === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
    }
    if (mainLoader) {
      setSmallLoaderExcel(false);
      setLoader(true);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      fromDate: fromDate,
      toDate: toDate,
      type: fileType,
      pageNo: pageNo,
      pageSize: sizePage,
      clientCode: clientCo,
      subbroktype: brokingDrop === "Broking Product" ? subBrokingType : "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axios.post(
        Dashboard_Client_Report.RevenueClientReport_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setError(false);
        if (fileType === "grid") {
          setTotalValue(res?.data);
          setCount(res?.data?.totalCount);
          if (pageNo > 1) {
            setGridVal((prev) => {
              return [...prev, ...res?.data?.revenueClients];
            });
          } else {
            setGridVal(res?.data?.revenueClients);
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setGridVal([]);
        if (fileType === "excel") {
          toast.error("Revenue Report does not exist.");
        } else if (fileType === "pdf") {
          toast.error("Revenue Report does not exist.");
        } else {
          setError(res?.message);
          setShow(false);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
      if (fileType === "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType === "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (clientCode !== "" && fileType === "grid") {
        toast.error("Something went wrong, Please try again later.");
        setClientCode("");
      }
    } finally {
      setLoader(false);
      setSearchLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setScrollLoader(false);
    }
  };
  useEffect(() => {
    if (fromDate && toDate !== "") {
      if (page > 1) {
        getRevenueClientReport("grid", 10, page, false);
      }
    }
  }, [page]);

  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        if (e.target.value === "grid") {
          document.querySelector("#SearchInput_RevenueR").value = "";
          getRevenueClientReport("grid", 10, 1, true);
          document.querySelector("#SearchInput_RevenueR").value = "";
          setClientCode("");
          setDateErrorResp("");
        } else {
          if (e.target.value === "pdf") {
            getRevenueClientReport("pdf", -1, 1, false);
          } else if (e.target.value === "excel") {
            getRevenueClientReport("excel", -1, 1, false);
          }
        }
      } else {
        setCheckDate(true);

        setDateErrorResp("Please Select Correct Date");
      }
    }
    setPage(1);
  };

  const handleScroll = (e) => {
    // setFileType("grid");
    setPageSize(10);
    const a = document.querySelector("#clientrevenue-scroll");

    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= pageSize * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };
  const onChangeDuration=()=>{
    setGridVal([]);
    setServerError(false);
    setDateErrorResp("");
    setError("")

  }

  const handleScrollUl = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !searchLoader) {
      if (!(count <= pageSize * page)) {
        setPage((prev) => prev + 1);
        setSearchLoader(true);
      }
    }
  };

  const handleDropDown = (e) => {
    document.querySelector("#SearchInput_RevenueR").value = "";
    setGridVal([]);
    setError(false);
    setShow(false);
    setClientCode("");
    setLoader(false);
    setSearchLoader(false);
    setBrokingDrop(e.target.value);
  };
  const handleSubType = (e) => {
    setGridVal([]);
    setClientCode("");
    if (brokingDrop !== "") {
      setSubBrokingType(e.target.value);
    } else {
      setSubBrokingType("");
    }
  };

  function handleClientName(data) {
    setGridVal([]);
    setError(false);
    setSearchLoader(true);
    getRevenueClientReport("grid", 10, 1, data === "", data);
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box revenue-report">
          <div className="figure-inlac">
            <h2 className="report-title">
              {Constants.Client_Wise_Revenue_Report}
            </h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-2 col-sm-3 col-12">
              <div className="form-group">
                <label className="form-label">{Constants.Product_Type}</label>
                <select onChange={handleDropDown}>
                  <option value="All">All</option>
                  <option value="Broking Product">Broking Product</option>
                </select>
              </div>
            </div>
            <div className="col-md-2 col-sm-3 col-12">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  setSelectDuration={setSelectDuration}
                  selectDuration={selectDuration}
                  onChangeDuration={onChangeDuration} />
              </div>
            </div>
             {customShow ?
              <div className="col-md-2 col-sm-3 col-12">
                <FromdateComponent
                  fromDate={handleFromDateChange}
                  formatDate={formatDate(fromDate)}
                  DateReverse={DateReverse}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
              : null
            }
            {customShow ?
              <div className="col-md-2 col-sm-3 col-12">
                <TodateComponent
                  toDate={handleToDateChange}
                  formatToDate={formatDate(toDate)}
                  DateReverse={DateReverse}
                  errorResponse={DateErrorResp}
                  clientWiseReportForCustomCalanderIcon={true}
                />
              </div>
              : null}
              {brokingDrop === "Broking Product" ? (
              <div className="col-md-2 col-sm-3 col-12">
                <div className="form-group">
                  <label className="form-label">Asset Sub Type</label>
                  <select onChange={handleSubType}>
                    <option value="EQUITY" selected={true}>
                      Equity
                    </option>
                    <option value="FNO">FNO</option>
                    <option value="MTF">MTF</option>
                  </select>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
            
           
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div className="row d-flex justify-content-between">
            <div
              className="col-md-3 col-sm-3 col-6"
            // onBlur={(e) => {
            //   handleBlurRevenue(e);
            // }}
            >
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>

                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    id="SearchInput_RevenueR"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                    }}

                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                      
                  }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                        onScroll={(e) => handleScrollUl(e)}
                      >
                        {/* {checkResp.lenght > 0 ? ( */}
                        {gridVal &&
                          gridVal.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              onClick={() => {
                                setShow(false);
                                document.querySelector(
                                  "#SearchInput_RevenueR"
                                ).value = item?.clientCode;
                                setClientCode(item?.clientCode);
                                // setLoader(true);
                              }}
                            >
                              <div> {item?.clientName}</div>
                              <div> {item?.clientCode}</div>
                            </li>
                          ))}
                        {searchLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div>
              <ReportTableHeader
                showEmailBtn={false}
                handleOnClick={handleOnClick}
                smallLoaderExcel={smallLoaderExcel}
                smallLoaderPdf={smallLoaderPdf}
              />
            </div>
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : gridVal && gridVal.length > 0 ? (
              <>
                <div>
                  <RevenueTable
                    error={error}
                    gridVal={gridVal}
                    subBrokingType={subBrokingType}
                    brokingDrop={brokingDrop}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    totalValue={totalValue}
                  />
                </div>
              </>
            ) : error ? (
              <h4 className="report-error-message">{noDataFound(error)}</h4>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default ClientWiseRevenueReport;
